<template>
  <div class="tblComp">

    <div class="toolbar">

      <select
          class="select_length tool_item"
          v-model="limit"
          @change="changeLength"
          v-if="paging  && count > 10"
      >
        <option v-for="(count, index) in length" :key="index" :value="count">{{ count }}</option>
      </select>
      <div class="div_search tool_item" v-if="searchInput">
        <input-search-comp
            :searching="searching"
            :clear="clear"
            v-model="search"
            :value="search"
            :placeholder="searchPlaceholder"
            :mask="searchMask"
        />
      </div>
      <button-comp
          v-if="btnAdd"
          class="btn_add tool_item"
          :classBtn="'btn_orange_min'"
          :textBtn="'Добавить'"
          :clickBtn="add"
      />
      <button-comp
          v-if="filters"
          class="btn_add tool_item"
          :classBtn="isFilter ? 'btn_orange_min' : 'btn_white_min'"
          :textBtn="'Фильтры'"
          :clickBtn="showFilters"
      />
      <button-comp
          v-if="data && hasExport"
          class="btn_add tool_item"
          :classBtn="'btn_orange_min'"
          :textBtn="'Экспорт'"
          :clickBtn="exportExcel"
      />
    </div>

    <div class="div_tbl">
      <!-- <label v-show="infoMessage" class="label_info_left">{{ infoMessage }}</label> -->
      <label class="label_info">Всего записей: {{ count }}</label>
      <label v-if="total" class="label_info">Итоговая сумма: {{ total }}</label>
      <table class="tbl_1">
        <thead>
        <tr>
          <th v-for="(col, index) in model" :key="index">
            {{ col.title }}
            <button class="btn_order" v-if="col.showOrder" @click="ordering(col.data)">
              {{ !col.order ? '|' : (col.order == 'desc' ? '&#8595;' : '&#8593;') }}
            </button>
          </th>
        </tr>
        </thead>
        <tbody v-if="data && data.length">
        <tr v-for="row in data" :key="row.id" @click="rowClick(row)">
          <td v-for="(col, index) in model" :key="index">
            <span v-if="col.type != 'checkbox'">{{ cellHandler(row[col.data], row, col.type, col.handler) }}</span>
            <input v-if="col.type == 'checkbox'" type="checkbox"
                   :checked="cellHandler(row[col.data], row, col.type , col.handler)"
                   @click="checkboxClick(row, col, $event.target.checked)">
          </td>
        </tr>
        </tbody>

        <tbody v-if="!data || !data.length">
        <tr class="tr_noodata">
          <td colspan="100%">Нет записей</td>
        </tr>
        </tbody>

      </table>
      <label class="label_info">Всего записей: {{ count }}</label>
      <label v-if="total" class="label_info">Итоговая сумма: {{ total }}</label>
    </div>

    <div class="div_paging">
      <ul v-if="paging && totalPages > 1">
        <li v-for="(pageNumber, index) in totalPages" :key="index"
            v-if="Math.abs(pageNumber - currentPage) < 3 || pageNumber == totalPages || pageNumber == 1">
          <button v-bind:key="pageNumber" @click="setPage(pageNumber)"
                  :class="{btn_page: 'btn_page', current: currentPage === pageNumber, last: (pageNumber == totalPages && Math.abs(pageNumber - currentPage) > 3), first:(pageNumber == 1 && Math.abs(pageNumber - currentPage) > 3)}">
            {{ pageNumber }}
          </button>
        </li>
      </ul>
    </div>

  </div>
</template>

<script>
import {excelParser} from '@/helpers/functions'

export default {
  name: 'tblComp',
  props: {
    searchPlaceholder: {type: String, default: () => 'Поиск...'},
    moduleName: {type: String, required: true},
    paging: {type: Boolean, default: () => false},
    hasExport: {type: Boolean, default: () => false},
    rowClick: Function,
    checkboxClick: Function,
    length: {type: Array, default: () => [10, 15, 25, 50]},
    lengthLimit: {type: Number, default: () => 10},
    searchInput: {type: Boolean, default: () => false},
    params: {
      type: Object,
      default: () => {
      }
    },
    btnAdd: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    filters: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    searchMask: {type: String, default: () => null},
    infoMessage: {type: String, default: () => ''}
  },
  data: function () {
    return {
      currentPage: 1,
      data: [],
      totalPages: 0,
      limit: this.lengthLimit,
      search: null,
      count: 0,
      total: 0
    }
  },
  created: function () {
    if (!this.paging) this.limit = -1
    this.getAll(1, {limit: this.limit})
  },
  components: {},
  computed: {
    model: function () {
      return this.$store.getters[`${this.moduleName}/getModel`]
    },
    isFilter: function () {
      return this.$store.getters[`${this.moduleName}/getIsFilter`]
    }
  },
  watch: {
    params: function () {
      this.getAll(1, {limit: this.limit})
    }
  },
  methods: {
    cellHandler(value, data, type, handler) {
      return this.$helpers.table.cellHandler(value, data, type, handler)
    },
    async getAll(currentPage, params) {
      this.currentPage = currentPage
      let data = Object.assign(params, this.params)
      await this.$store.dispatch(`${this.moduleName}/getAll`, {params: params})
      let result = this.$store.getters[`${this.moduleName}/getAll`]
      this.data = result.data.data
      this.totalPages = Math.ceil(result.data.count / this.limit)
      this.count = result.data.count
      this.total = result.data.total
    },
    changeLength() {
      this.getAll(1, {limit: this.limit})
    },
    setPage(pageNumber) {
      this.getAll(pageNumber, {offset: (pageNumber - 1) * this.limit, limit: this.limit})
    },
    searching() {
      let search = this.search
      if (search) {
        if (this.searchMask) search = search.replace(/[()_-]/g, '')
        this.getAll(1, {search, limit: this.limit})
      }
      ;
    },
    clear() {
      this.search = null
      this.getAll(1, {limit: this.limit})
    },
    add() {
      this.$store.dispatch(`${this.moduleName}/toAdd`)
    },
    showFilters() {
      this.$store.commit(`${this.moduleName}/setShowFilters`, true)
    },
    exportExcel() {
      let data = []
      this.$data.data.map(obj => {
        let newObj = {}
        data.push(newObj)
        Object.keys(this.model).forEach(key => {
          console.log(this.model[key].title)
          newObj[this.model[key].title] = obj[this.model[key].data]
        })
      })
      excelParser(this.$store, this.moduleName, this.count).exportDataFromJSON(data, this.model, null, null)
    },
    ordering(data) {
      this.$store.commit(`${this.moduleName}/setOrder`, {param: data})
      this.getAll(1, {search: this.search, limit: this.limit})
    }
  }
}
</script>

<style scoped lang="scss">
.tblComp {
  display: grid;
  grid-template-rows: auto 1fr 116px;
  grid-template-columns: 1fr;
  width: 100%;
  min-width: 320px;
}

.toolbar {
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr auto auto auto;
  height: 116px;
}

.select_length {
  width: 75px;
  object-fit: contain;
  border-radius: 4px;
  background-color: #ff8200;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.3px;
  color: #ffffff;
  border: none;
}

.div_search {
  width: 232px;
}

.btn_add {
  width: 100px;
}

.tool_item {
  height: 36px;
  margin: 40px 32px 40px auto;
}

.div_tbl {
  margin: 0 32px 0 32px;
  overflow: auto;
  width: auto;
}

.label_info {
  float: right;
  margin: 5px 10px 5px auto;
}

.label_info_left {
  float: left;
  margin: 5px 10px 5px auto;
}

.tbl_1 {
  border: 2px solid #bababa;
  border-radius: 9px 9px 9px 9px;
  -moz-border-radius: 9px 9px 9px 9px;
  -webkit-border-radius: 9px 9px 9px 9px;
  border-spacing: 0;
  width: 100%;
}

.tbl_1 > tbody > tr:hover {
  background-color: #ff8200;
  cursor: pointer;
}

.tbl_1 th:first-child {
  border: none;
}

.tbl_1 td:first-child {
  border-left: none;
}

.purchasesComp .tbl_1 th:first-child,
.purchasesComp .tbl_1 td:first-child {
  width: 100px;
}

.tbl_1 th {
  border-left: 2px solid #bababa;
  padding: 16px 24px 16px 24px;
  object-fit: contain;
  font-size: 16px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.4px;
  color: #ff8200;
}

.tbl_1 td {
  border-left: 2px solid #bababa;
  border-top: 2px solid #bababa;
  padding: 16px 24px 16px 24px;
  object-fit: contain;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.4px;
  text-align: center;
  color: #202020;
}

.div_paging {
  margin: 40px auto auto auto;
}

ul {
  margin: 0;
  padding: 0;
}

li {
  display: inline;
  margin: 0 2px 0 2px;
}

.btn_page {
  width: auto;
  height: 36px;
  object-fit: contain;
  border-radius: 4px;
  border: solid 1px #bababa;
  padding: 0 16px;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.3px;
  text-align: center;
  color: #202020;
  background-color: #ffffff;
}

.btn_page.current {
  background-color: #ff8200;
  width: auto;
  height: 36px;
  object-fit: contain;
  border-radius: 4px;
  border: none;
  padding: 0 16px;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.3px;
  text-align: center;
  color: #ffffff;
}

.btn_page.first::after {
  content: '...'
}

.btn_page.last::before {
  content: '...'
}

.div_tbl::-webkit-scrollbar {
  width: 10px;
}

.div_tbl::-webkit-scrollbar-track {
  border: 1px solid #bababa;
}

.div_tbl::-webkit-scrollbar-thumb {
  background: #ff8200;
}

button:active, button:hover {
  opacity: 0.5;
  cursor: pointer;
}

.div_tbl_null {
  width: 100%;
}

.btn_order {
  object-fit: contain;
  border-radius: 4px;
  border: solid 1px #bababa;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.3px;
  text-align: center;
  color: #202020;
  background-color: #ffffff;
}

.div_filters_close {
  background-color: grey;
}

.div_filters_open {
  background-color: grey;
}

@media screen and (max-width: 1140px) {
}

@media screen and (max-width: 960px) {
}

@media screen and (max-width: 720px) {
  .tblComp {
    grid-template-rows: auto 1fr 116px;
  }
  .toolbar {
    grid-template-rows: 1fr;
    grid-template-columns: 1fr 1fr 1fr;
  }
  .tool_item {
    margin: 30px auto 30px auto;
  }
}

@media screen and (max-width: 540px) {
}

@media screen and (max-width: 480px) {
  .toolbar {
    grid-template-rows: 1fr 1fr 1fr;
    grid-template-columns: 1fr;
  }
  .tool_item {
    margin: 10px auto 10px auto;
  }
}

@media screen and (max-width: 320px) {
  .toolbar {
    grid-template-rows: 1fr 1fr 1fr;
    grid-template-columns: 1fr;
  }
  .tool_item {
    margin: 10px auto 10px auto;
  }
  .div_search {
    width: calc(100% - 64px);
  }
  .btn_add {
    width: calc(100% - 64px);
  }
}
</style>
